import React from 'react'
import { Grid, TextField } from '@mui/material'

export const CoordsComponent = ({lat, lng, onChange, errors}) => {
  return (
    <Grid container spacing={1} style={{
      marginBottom: 8
    }}>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Latitud"
          variant="outlined"
          fullWidth
          name="coordLat"
          value={lat}
          onChange={onChange}
          error={errors?.coordLat}
          helperText={errors?.coordLat}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Longitud"
          variant="outlined"
          fullWidth
          name="coordLng"
          value={lng}
          onChange={onChange}
          error={errors?.coordLng}
          helperText={errors?.coordLng}
        />
      </Grid>
    </Grid>
  )
}
